import { useState } from "react";
import { Play } from "lucide-react";

interface WelcomeVideo {
  id: string;
  title: string;
  video_url: string;
}

interface HeroVideoPlayerProps {
  heroVideo: WelcomeVideo;
}

export function HeroVideoPlayer({ heroVideo }: HeroVideoPlayerProps) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    // Silently handle video load errors to prevent console noise
    setHasError(true);
  };

  return (
    <div className="relative w-full h-full">
      {(!isLoaded || hasError) && (
        <div className="absolute inset-0 flex items-center justify-center bg-black">
          <Play className="w-16 h-16 text-muted-foreground/50 animate-pulse" />
        </div>
      )}
      {!hasError && (
        <video
          src={heroVideo.video_url}
          controls
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          webkit-playsinline="true"
          onLoadedData={() => setIsLoaded(true)}
          onCanPlay={(e) => {
            const video = e.currentTarget;
            video.play().catch(() => {});
          }}
          onError={handleError}
          className={`w-full h-full object-contain ${isLoaded ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300`}
        />
      )}
    </div>
  );
}
